module.exports = __webpack_public_path__ + "static/media/fly0017.cc1d3c5a.webp";